import React, { useEffect } from "react";
import { Row, Col, Card, Typography, Descriptions } from "antd";
import { getAmount, getQuantityUnit, isoDateToHumanReadableDate } from "../../../../../Util";
import useProcuringEntityPackage from "../../../../../hooks/useProcuringEntityPackage";
import ActionBar from "../../../../components/ActionBar";
import Loader from "../../Loader";
import "./styles.css";

const { Title } = Typography;

const ContractorContractInfo = ({ match }) => {
  const {
    params: { packageId },
  } = match;
  const { contractInfo, loading, procuringEntityPackage } = useProcuringEntityPackage(packageId);
  const packageName = procuringEntityPackage?.name || "";

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  if (loading) {
    return <Loader flexDirection="column" fontSize={54} />;
  }

  return (
    <div className="contractor-details-container" style={{ padding: "24px", backgroundColor: "#f0f2f5" }}>
      <Row gutter={16} align="middle" style={{ width: "100%" }}>
        <ActionBar
          actionButtonProp={{
            title: `${packageName}: Contractor Contract Information`,
            className: "contractor-header-title"
          }}
        />
      </Row>

      <Row gutter={1} style={{ marginTop: "20px" }}>
        <Col span={24}>
          <Card
            bordered={false}
            style={{
              backgroundColor: "#ffffff",
              borderRadius: "12px",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
              padding: "24px",
            }}
          >
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start'}}>
              <Title
                level={4}
                style={{
                  marginBottom: 24,
                  color: "#0f6788",
                  textTransform: "uppercase",
                  fontWeight: "bold",
                }}
              >
                Contractor Contract Information
              </Title>
            </div>
            
            <Descriptions
              bordered
              column={1}
              layout="horizontal"
              size="large"
              labelStyle={{
                fontWeight: "bold",
                color: "#0f6788",
                textTransform: "uppercase",
              }}
              contentStyle={{
                fontSize: "16px",
                color: "#595959",
              }}
            >
              <Descriptions.Item label="Contractor Name">
                {contractInfo?.contract?.contractor?.name || "--//--"}
              </Descriptions.Item>
              <Descriptions.Item label="Contract Sum">
                {getAmount(contractInfo?.contract?.original_contract_sum) || "--//--"}
              </Descriptions.Item>
              <Descriptions.Item label="Original Contract Duration">
                {getQuantityUnit(contractInfo?.contract?.original_contract_period) || "--//--"}
              </Descriptions.Item>
              <Descriptions.Item label="Commencement Date">
                {isoDateToHumanReadableDate(
                  contractInfo?.contract?.date_of_commencement_of_works
                ) || "--//--"}
              </Descriptions.Item>
              <Descriptions.Item label="Original Completion Date">
                {isoDateToHumanReadableDate(
                  contractInfo?.contract?.date_of_contract_completion
                ) || "--//--"}
              </Descriptions.Item>
              <Descriptions.Item label="Revised Completion Date">
                {isoDateToHumanReadableDate(contractInfo?.contract?.revised_date_of_contract_completion) || "--//--"}
              </Descriptions.Item>
              <Descriptions.Item label="Contract Description">
                {contractInfo?.contract?.name || "--//--"}
              </Descriptions.Item>
              <Descriptions.Item label="Contract Number">
                {contractInfo?.contract?.contract_no || "--//--"}
              </Descriptions.Item>
              <Descriptions.Item label="Revised Contract Sum">
                {getAmount(contractInfo?.contract?.revised_contract_sum) || "--//--"}
              </Descriptions.Item>
              {/* <Descriptions.Item label="Revised Contract Period">
                {getQuantityUnit(contractInfo?.contract?.revised_contract_period) || "--//--"}
              </Descriptions.Item> */}
              <Descriptions.Item label="End of Defect Liability Period (DLP)">
                {isoDateToHumanReadableDate(
                  contractInfo?.contract?.defects_liability_notification_period
                ) || "--//--"}
              </Descriptions.Item>
              <Descriptions.Item label="Justification for EOT">
                {contractInfo?.contract?.eot_justification || "--//--"}
              </Descriptions.Item>
              <Descriptions.Item label="Advance Recovery Amount">
                {getAmount(contractInfo?.contract?.advance_recovery_amount) || "--//--"}
              </Descriptions.Item>
              <Descriptions.Item label="Extension of Time Granted">
                {contractInfo?.contract?.extension_of_time_granted?.quantity || "--//--"} {" "}
                {contractInfo?.contract?.extension_of_time_granted?.unit}
              </Descriptions.Item>
              <Descriptions.Item label="Extension of Time (EOT) Applied">
                {contractInfo?.contract?.extension_of_time?.quantity || "--//--"} {" "}
                {contractInfo?.contract?.extension_of_time?.unit}
              </Descriptions.Item>
              <Descriptions.Item label="Deduction of Retention Amount">
                {getAmount(contractInfo?.contract?.deduction_of_retention_amount) || "--//--"}
              </Descriptions.Item>
            </Descriptions>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default ContractorContractInfo;
